/**
 * Where an action menu goes, so it never runs off the screen (Matt, 2026-09-24: "this has actually
 * been a problem for a while with action menus on Milestones in the outline").
 *
 * Opens below the trigger when it fits; otherwise above; and when it fits on neither side (a long
 * milestone menu near the middle of a short window, or inside a popup frame), it takes the roomier side
 * and caps its height so the menu scrolls inside itself. Shared by the outline engine's menus
 * (outline.js) and React's <ActionMenu>, so both behave the same.
 *
 * @param {DOMRect} btn          the trigger's getBoundingClientRect()
 * @param {number}  naturalH     the menu's full height (scrollHeight, before any cap)
 * @param {number}  menuW        the menu's width
 * @returns {{ top: number, left: number, maxHeight: number|null }}
 */
export function placeMenu(btn, naturalH, menuW) {
  const GAP = 4, EDGE = 8
  const vh = window.innerHeight, vw = window.innerWidth
  const below = vh - btn.bottom - GAP - EDGE
  const above = btn.top - GAP - EDGE
  let top, maxHeight = null
  if (naturalH <= below) top = btn.bottom + GAP
  else if (naturalH <= above) top = btn.top - GAP - naturalH
  else if (below >= above) { top = btn.bottom + GAP; maxHeight = Math.max(120, below) }
  else { maxHeight = Math.max(120, above); top = btn.top - GAP - maxHeight }
  if (top < EDGE) top = EDGE
  let left = btn.left
  if (left + menuW > vw - EDGE) left = Math.max(EDGE, vw - menuW - EDGE)
  return { top, left, maxHeight }
}
